import { useQuery } from "@apollo/client";
import { ReactElement } from "react";
import { useParams } from "react-router-dom";

import {
  GetInboxQuery,
  GetInboxQueryVariables,
  InboxType,
} from "~frontend/__generated__/graphql";
import { AsyncWrapper } from "~frontend/components/AsyncWrapper";
import ErrorCard from "~frontend/components/ErrorCard";
import { GET_INBOX } from "~frontend/graphql/inboxes";
import { InboxAssignments } from "~frontend/routes/subaccounts/inboxes/InboxAssignments";

export function InboxAllCampaigns(): ReactElement {
  const { inboxId: maybeInboxId } = useParams<{ inboxId: string }>();
  const inboxId = maybeInboxId!;

  const { data, loading, error, refetch } = useQuery<
    GetInboxQuery,
    GetInboxQueryVariables
  >(GET_INBOX, { variables: { input: { inboxId } }, pollInterval: 60 * 1000 });

  return (
    <AsyncWrapper loading={loading} errors={error} data={data}>
      {({ getInbox }) => {
        if (
          getInbox.inboxType === InboxType.General ||
          getInbox.inboxType === InboxType.Escalation
        ) {
          return <InboxAssignments inbox={getInbox} refetchInbox={refetch} />;
        }
        return <ErrorCard errors={[{ message: "invalid inbox type" }]} />;
      }}
    </AsyncWrapper>
  );
}
